var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-loading"},[(_vm.loading)?_c('div',{staticClass:"upload-spinner"}):_vm._e(),(_vm.isEmpty)?_c('div',{staticClass:"no-grid-content"},[_vm._v("No items are available")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }